// Alergeno Icon Component with Official EU Allergen Images
import React from 'react';

// Official EU allergen images (individual files)
// Map allergen names from database to image files
const ALERGENO_ICONS = {
  // Nombres exactos de la base de datos
  'Gluten': { 
    image: 'gluten.png',
    label: 'Gluten'
  },
  'Crustáceos': { 
    image: 'crustaceos.png',
    label: 'Crustáceos'
  },
  'Marisco': { 
    image: 'crustaceos.png',
    label: 'Marisco'
  },
  'Huevos': { 
    image: 'huevos.png',
    label: 'Huevos'
  },
  'Huevo': { 
    image: 'huevos.png',
    label: 'Huevo'
  },
  'Pescado': { 
    image: 'pescado.png',
    label: 'Pescado'
  },
  'Cacahuetes': { 
    image: 'cacahuetes.png',
    label: 'Cacahuetes'
  },
  'Soja': { 
    image: 'soja.png',
    label: 'Soja'
  },
  'Lácteos': { 
    image: 'lacteos.png',
    label: 'Lácteos'
  },
  'Frutos de cáscara': { 
    image: 'frutos-cascara.png',
    label: 'Frutos de cáscara'
  },
  'Frutos secos': { 
    image: 'frutos-cascara.png',
    label: 'Frutos secos'
  },
  'Apio': { 
    image: 'apio.png',
    label: 'Apio'
  },
  'Mostaza': { 
    image: 'mostaza.png',
    label: 'Mostaza'
  },
  'Granos de sésamo': { 
    image: 'sesamo.png',
    label: 'Granos de sésamo'
  },
  'Sésamo': { 
    image: 'sesamo.png',
    label: 'Sésamo'
  },
  'Dióxido de azufre y sulfitos': { 
    image: 'sulfitos.png',
    label: 'Dióxido de azufre y sulfitos'
  },
  'Sulfitos': { 
    image: 'sulfitos.png',
    label: 'Sulfitos'
  },
  'Moluscos': { 
    image: 'moluscos.png',
    label: 'Moluscos'
  },
  'Altramuces': { 
    image: 'altramuces.png',
    label: 'Altramuces'
  }
};

const AlergenoIcon = ({ nombre, size = 'md', showLabel = false, className = '' }) => {
  const iconData = ALERGENO_ICONS[nombre] || { 
    image: null, 
    label: nombre
  };
  
  const sizes = {
    'sm': 32,
    'md': 40,
    'lg': 48,
    'xl': 64
  };
  
  const iconSize = sizes[size];

  return (
    <div 
      className={`inline-flex items-center gap-2 ${className}`}
      title={iconData.label}
    >
      {iconData.image ? (
        <img 
          src={`/alergenos/${iconData.image}`}
          alt={iconData.label}
          className="inline-block rounded-lg shadow-sm"
          style={{ 
            width: `${iconSize}px`,
            height: `${iconSize}px`,
            objectFit: 'contain'
          }}
        />
      ) : (
        <div 
          className="inline-flex items-center justify-center bg-gray-200 rounded-lg"
          style={{ 
            width: `${iconSize}px`,
            height: `${iconSize}px`
          }}
        >
          <span className="text-gray-500 text-xs">?</span>
        </div>
      )}
      {showLabel && (
        <span className="text-sm text-gray-700 font-medium">{iconData.label}</span>
      )}
    </div>
  );
};

// Component to display multiple allergens
export const AlergenoList = ({ alergenos, size = 'md', showLabels = false, maxDisplay = null }) => {
  const displayAlergenos = maxDisplay ? alergenos.slice(0, maxDisplay) : alergenos;
  const remaining = maxDisplay && alergenos.length > maxDisplay ? alergenos.length - maxDisplay : 0;

  return (
    <div className="flex flex-wrap gap-1.5 items-center">
      {displayAlergenos.map((alergeno, index) => (
        <AlergenoIcon 
          key={index} 
          nombre={alergeno.nombre} 
          size={size}
          showLabel={showLabels}
        />
      ))}
      {remaining > 0 && (
        <span className="text-xs text-gray-500 font-medium">+{remaining} más</span>
      )}
    </div>
  );
};

export default AlergenoIcon;
